@if (!svgIcon) {
  <mat-icon
    class="material-symbols-outlined {{ class }}"
    [ngClass]="{ 'd-flex': isFlexBox, 'vertical-middle': !isFlexBox }"
    [matBadgeHidden]="badgeHidden"
    [matBadge]="badge"
    aria-hidden="false"
  >
    <ng-template *ngTemplateOutlet="iconContent"> </ng-template>
  </mat-icon>
}
@if (svgIcon) {
  <mat-icon
    class="{{ class }}"
    [ngClass]="{ 'd-flex': isFlexBox, 'vertical-middle': !isFlexBox }"
    [svgIcon]="svgIcon"
    [matBadgeHidden]="badgeHidden"
    [matBadge]="badge"
    aria-hidden="false"
  ></mat-icon>
}

<ng-template #iconContent>
  <ng-content></ng-content>
</ng-template>
